/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import JsBarcode from "jsbarcode";
import CommonButtons from "../shared/components/CommonButtons";
import { useUser } from "src/shared/context/UserContext";
import { COMPANY_NAME } from "src/shared/utils/brand";
import noImage from "src/assets/Images/imetanic-logo.png";
import { Button } from "src/business-types/grocery/components/Button";
import { formatTerms, ThermalPrinterTestProps } from "./PrintConfigration";
import { formatAmount } from "src/business-types/grocery/layouts/orders/PaymentHistory";

const ThermalPrinter2: React.FC<ThermalPrinterTestProps> = ({ PrintData, BtnName, openPrint, isClosed, ledgerPaid, barcodeTrue, icon, className, handleAppPrint, printerCheck }) => {
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [barcodeDataUrl, setBarcodeDataUrl] = useState<string>("");
  const { user, userConfigration } = useUser();

  const roundAmount = (value: any): string => {
    if (value === undefined || value === null || value === "") return "0.00";
    const num = Number(value);
    if (isNaN(num)) return "0.00";
    return (Math.round(num * 100) / 100).toFixed(2);
  };

  const formatNumber = (value: number) => {
    return value < 1000 ? value.toString().padStart(4, "0") : value.toString();
  };

  const toBoolean = (value: any) => value === true || value === "true";
  const deliveryFeeEnabled = toBoolean(userConfigration?.deliveryFeeEnabled);
  const parcelFeeEnabled = toBoolean(userConfigration?.parcelFeeEnabled);
  const tipsEnabled = toBoolean(userConfigration?.tipsEnabled);
  const billNoEnabled = toBoolean(userConfigration?.billNoEnabled);
  const orderIdEnabled = userConfigration?.orderIdEnabled !== undefined ? toBoolean(userConfigration?.orderIdEnabled) : true;
  const enabileTermsAndConditions = toBoolean(userConfigration?.enableTermsAndConditions);

  const returnOrderQty = () => {
    return `
        
    <style>
      table {
        width: 100%;
        border-collapse: collapse;
      }

      th, td {
        padding: 4px 2px;
        text-align: left;
      }

      /* Column Width Control */
      .col-no { width: 5%; }
      .col-name { width: 40%; }
      .col-qty { width: 25%; text-align: left; }
      .col-price { width: 15%; text-align: right; }
      .col-total { width: 15%; text-align: right; }

      /* Optional borders / spacing for rows */
      tr {
        padding-bottom: 4px;
      }
    </style>
    <div style="font-weight:bold; margin-top:10px; text-align:center;">
     Return Details
   </div>
    ${userConfigration.orderTableType === "Table Type:1" ? normalReturnDesign() : ""}
    ${userConfigration.orderTableType === "Table Type:2" ? tailerShopOrderReturnDetails() : ""}

     <div style="border-bottom: 1px dashed #000; margin-bottom: 10px;">
      <div style="display:flex; justify-content:space-between;"><span>Return Subtotal(ر.ق):</span> <span>${roundAmount(PrintData?.returnProducts?.reduce((sum, product) => sum + product.returnedQty * product.price, 0))} </span></div>
    <div>
    </div>`;
  };

  const tailerShopOrderReturnDetails = () => {
    return `
    <div style = "border-bottom: 1px dashed #000;">
    <div style="font-weight:bold;">
     Items:
   </div>
    <hr/>

    ${PrintData?.returnProducts
        ?.map(
          (product, index) => `
   
   <div style="font-weight:bold;">
     ${index + 1}. ${product.productName}<br/>${product.arabicword ? `<span style="font-size: 10px; margin-left: 10px; font-style: italic; font-family: 'Tahoma', sans-serif;">${product.arabicword}</span>` : ""}
   </div>
   

   <div style="display:flex; justify-content:space-between; padding-left:10px; ">
     <div>
       ${product.returnedQty} ${product.uom || ""} X ${roundAmount(product.price)}
     </div>
     <div>
       ${roundAmount(product.returnedQty * product.price)}
     </div>
   </div>
   <br/>
 `,
        )
        .join("")}
    </div>
    `;
  };

  const normalReturnDesign = () => {
    return `
    <table style="width: 100%; border-collapse: collapse; margin-bottom: 5px; border-bottom: 1px dashed #000;">
      <thead style="border-bottom: 1px dashed #000;">
         <tr>
          <th class="col-no">#</th>
          <th class="col-name">Product<br/> Name</th>
          <th class="col-qty">Return<br/> Qty</th>
          <th class="col-price">Price</th>
          <th class="col-total">Total</th>
        </tr>
      </thead>
      <tbody>
        ${PrintData?.returnProducts
        ?.map(
          (p, index) => `
          <tr>
           <td class="col-no" style>${index + 1}</td>
              <td class="col-name">
              ${p.productName}
              <br/>
              <span style="font-size: 10px; font-style: italic; font-family: 'Tahoma', sans-serif;">
                ${p.arabicword ?? ""}
              </span>
            </td>
            <td class="col-qty">${p.returnedQty}${PrintData?.businessType === "Grocery" ? p.uom?.substring(0, 3).toLowerCase() : ""}</td>           
            <td class="col-price">${roundAmount(p.price)}</td>
            <td class="col-total">${roundAmount(p.netAmount)}</td>
          </tr>
         
        `,
        )
        .join("") || ""
      }
      </tbody>
    </table>`;
  };

  const printHistory = () => {
    if (!PrintData?.payMentHistory || PrintData.payMentHistory.length === 0) return "";
    return `
      <div style="margin-top: 8px; border-top: 1px dashed #000; padding-top: 5px; border-bottom: 1px dashed #000;">
        <div style="font-weight:bold; text-align:center; margin-bottom:5px;">Payment History</div>
        <table style="width:100%;">
          <thead>
            <tr style="border-bottom:1px dashed #000;">
              <th style="text-align:left;">Date</th>
              <th style="text-align:center;">Method</th>
              <th style="text-align:right;">Received</th>
              <th style="text-align:right;">Refund</th>
              <th style="text-align:right;">Balance</th>
            </tr>
          </thead>
          <tbody>
            ${PrintData.payMentHistory
        .map(
          (p) => `
              <tr>
                <td>${p.date ?? p.payment_on}</td>
                <td style="text-align:center;">${p.Paymentmethod}</td>
                <td style="text-align:right;">${roundAmount(p.adjustAmount ? p.adjustAmount : p.ReceivedAmount)}</td>
                <td style="text-align:right;">${roundAmount(p.refundAmount ?? 0)}</td>
                ${p.balance ? `<td style="text-align:right;">${formatAmount(p.balance)}</td>` : "<td style='text-align:right;'>(Pay in ledger)</td>"} 
              </tr>`,
        )
        .join("")}
          </tbody>
        </table>
      </div>
    `;
  };

  const ledgerBalance = `${roundAmount( Math.abs(Number(ledgerPaid?.PreviousBalance || 0)) - Math.abs(Number(ledgerPaid?.Paid || 0)) - Math.abs(Number(ledgerPaid?.discount || 0)))}`;

  const ledgerList = () => {
    if (!ledgerPaid) return "";
    return `
    <div style="width:100%">
      <div style="border-bottom: 1px dashed #000; margin-bottom: 5px; padding-bottom: 3px;">
      <div style="display:flex; justify-content:space-between;">
        <div><strong>Cus.Name :</strong> ${ledgerPaid?.CustomerName}</div>
        ${billNoEnabled
        ? ` <div>
            <strong>Bill No:</strong> 
            ${ledgerPaid?.billNo ? `<strong>${formatNumber(ledgerPaid?.billNo)}</strong>` : ""}
            </div>`
        : ""
      } 
      </div>
        <div style="display:flex; justify-content:space-between;">
          <div><strong>Cus.Phone:</strong> ${ledgerPaid?.CustomerPhon}</div>
          ${ledgerPaid?.clientId ? `<div><strong>Client ID:</strong> ${ledgerPaid?.clientId}</div>` : ""}
        </div>
      </div>

      <div style="border-bottom: 1px dashed #000; margin-bottom: 5px; padding-bottom: 3px;">
        <div style="display:flex; justify-content:space-between;">
          <div><strong>Pay. Type:</strong>${ledgerPaid?.paymentMethod ?? ""}</div>
        </div>
        <div style="display:flex; justify-content:space-between;">
          <div><strong>Date:</strong> ${ledgerPaid?.Date ?? ""} </div> 
          <div><strong>Time:</strong> ${ledgerPaid?.Time ?? ""}</div>
        </div>
      </div>
      
      <div style="width: 100%; padding-bottom:6px;">
        <p style="display: flex; justify-content: space-between; width: 98%; margin:0;">
        <strong>${ledgerPaid?.previousLabel || "Prev. Balance"}:</strong>
          ${roundAmount(Math.abs(Number(ledgerPaid?.PreviousBalance || 0)))} ر.ق
        </p>

         <p style="display: flex; justify-content: space-between; width: 98%; margin:0;">
          <strong>Discount(تخفيض):</strong>
          ${roundAmount(Math.abs(Number(ledgerPaid?.discount) || 0))} ر.ق
        </p>

        <p style="display: flex; justify-content: space-between; width: 98%; margin:0;">
          <strong>${ledgerPaid?.paidLabel || "Balance Paid"}:</strong>
          ${roundAmount(Math.abs(Number(ledgerPaid?.Paid) || 0))} ر.ق
        </p>

        <p style="display: flex; justify-content: space-between; width: 98%; margin:0;">
          <strong>${ledgerPaid?.balanceLabel || "New Balance"}:</strong>
          ${ledgerBalance} ر.ق
        </p>
      </div>
    </div>
   `;
  };

  /** ===============================
   * Customer CONTENT
   * =============================== */

  const customerData = () => {
    return `
        <div style="border-bottom: 1px dashed #000; margin-bottom: 5px; padding-bottom: 3px;">
      <div><strong>Cus.Name :</strong> ${PrintData?.CustomerName ?? ""}</div>
      <div style="display:flex; justify-content:space-between;">
        <div><strong>Cus.Phone:</strong> ${PrintData?.CustomerPhon ?? ""}</div> 
        ${PrintData?.clientId ? `<div><strong>Client ID:</strong> ${PrintData.clientId}</div>` : ""}
      </div>
    </div>`;
  };

  /** ===============================
   * Order CONTENT
   * =============================== */
  const orderData = () => {
    const billNoHtml = billNoEnabled && PrintData?.billNo ? `<div><strong>Bill No:</strong> ${formatNumber(PrintData.billNo)}</div>` : "";
    const orderIdHtml = orderIdEnabled && PrintData?.OrderId ? `<div><strong>Order ID:</strong> ${PrintData?.OrderId}</div>` : "";

    return `
    <div style="border-bottom: 1px dashed #000; margin-bottom: 5px; padding-bottom: 3px;">
      ${orderIdHtml}
      ${billNoHtml}
      <div style="display:flex; justify-content:space-between;">
        <div><strong>Status:</strong> ${PrintData?.OrderStatus ?? ""}</div>
        <div><strong>Pay. Type:</strong>${PrintData?.paymentMethod ?? ""}</div>
      </div>
      <div style="display:flex; justify-content:space-between;">
        <div><strong>Date:</strong> ${PrintData?.Date ?? ""} </div> 
        <div><strong>Time:</strong> ${PrintData?.Time ?? ""}</div>
      </div>
    </div>`;
  };

  /** ===============================
   * Company CONTENT
   * =============================== */

  const companyData = () => {
    return `
        <div style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px dashed #000; padding-bottom: 5px; margin-bottom: 5px;">
      <div style="flex: 1; text-align: left;">
        ${user?.companyLogo
        ? `<img
         src="${user?.companyLogo}"
         onerror="this.src=${noImage}"
         style="width: 60px; height: 60px; border-radius: 8px; object-fit: contain;"/>`
        : `<img src="${noImage}" style="width: 60px; height: 60px; border-radius: 8px; object-fit: contain;" />`
      }
      </div>
      <div style="flex: 2; text-align: right;">
        <div style="font-weight: bold;">${user?.orgName}</div>
        <div>${user?.orgArabicName}</div>
        ${user?.businessLocation ? `<div>${user?.businessLocation}</div>` : ""}
        <div> ${user?.phones?.[0]?.phone || ""}</div>
      </div>
    </div>`;
  };

  /** ===============================
   * Company CONTENT
   * =============================== */

  const orderDetails = () => {
    return `
        
    <style>
      table {
        width: 100%;
        border-collapse: collapse;
      }

      th, td {
        padding: 4px 2px;
        text-align: left;
      }

      /* Column Width Control */
      .col-no { width: 5%; }
      .col-name { width: 40%; }
      .col-qty { width: 25%; text-align: left; }
      .col-price { width: 15%; text-align: right; }
      .col-total { width: 15%; text-align: right; }

      /* Optional borders / spacing for rows */
      tr {
        padding-bottom: 4px;
      }
    </style>
    ${userConfigration.orderTableType === "Table Type:1" ? normalDesign() : ""}
    ${userConfigration.orderTableType === "Table Type:2" ? tailerShopOrderDetails() : ""}

    <div style="border-bottom: 1px dashed #000; margin-top: 5px; padding-bottom: 5px;">
      <div style="display:flex; justify-content:space-between;"><span>Subtotal(ر.ق):</span> <span>${roundAmount(PrintData?.total)} </span></div>
      ${parcelFeeEnabled
        ? `
      <div style="display:flex; justify-content:space-between;">
        <span>Parcel Fee (ر.ق):</span>
        <span>+${roundAmount(PrintData?.parcelFee)}</span>
      </div>
`
        : ""
      }

      
      <div style="display:flex; justify-content:space-between;"><span>Discount(ر.ق):</span> <span>-${roundAmount(PrintData?.discount)} </span></div>
      ${deliveryFeeEnabled && PrintData
        ? `
    <div style="display:flex; justify-content:space-between;">
      <span>Delivery Fee (ر.ق):</span>
      <span>+${roundAmount(PrintData.deliveryFee)}</span>
    </div>`: ""
      }

      ${tipsEnabled && PrintData ? `
      <div style="display:flex; justify-content:space-between;">
        <span>Tip (نصيحة):</span>
        <span>+${roundAmount(PrintData?.Tip || PrintData?.tip)}</span>
      </div>`: ""
      }

      <div style="display:flex; justify-content:space-between; font-weight:bold;"><span>Total(ر.ق):</span> <span>${roundAmount(PrintData?.subtotal)} </span></div>
      
      

${
  Number(PrintData?.prvPaid || 0) > 0
    ? `
<div style="display:flex; justify-content:space-between; border-top: 1px solid black;">
  <span>Prev. Paid (مدفوع):</span>
  <span>${roundAmount(PrintData?.prvPaid)}</span>
</div>

<div style="display:flex; justify-content:space-between;">
  <span>Prev. Balance (المبلغ المتبقي):</span>
  <span>${roundAmount(PrintData?.prvBalance)}</span>
</div>
`
    : ""
}

<div style="display:flex; justify-content:space-between; border-top: 1px solid black;">
  <span>Paid(ر.ق):</span>
  <span>${roundAmount(PrintData?.Paid)} </span>
</div>

<div style="display:flex; justify-content:space-between;font-weight:bold;">
  <span>Due(ر.ق):</span>
  <span>${roundAmount(PrintData?.unpaid)} </span>
</div>
    </div>`;
  };

  const tailerShopOrderDetails = () => {
    return `
    <div style = "border-bottom: 1px dashed #000;">
    <div style="font-weight:bold;">
     Items:
   </div>
    <hr/>

    ${PrintData?.Products?.map(
      (product, index) => `
   
   <div style="font-weight:bold;">
     ${index + 1}. ${product.productName}<br/>${product.arabicword ? `<span style="font-size: 10px; font-style: italic; margin-left: 10px; font-family: 'Tahoma', sans-serif;">${product.arabicword}</span>` : ""}
   </div>

   <div style="display:flex; justify-content:space-between; padding-left:10px; ">
     <div>
       ${product.quantity} ${product.uom || ""} X ${roundAmount(product.amount)}
     </div>
     <div>
       ${roundAmount(product.quantity * product.amount)}
     </div>
   </div>

   ${product.addOns && product.addOns.length > 0
          ? product.addOns
            .map(
              (s) => `
         <div style="display:flex; justify-content:space-between; font-size:12px; padding-left:10px;">
           <div>${s.text}</div>
           <div>${roundAmount(s.amount)}</div>
         </div>
       `,
            )
            .join("")
          : ""
        }

   <br/>
 `,
    ).join("")}
    </div>
    `;
  };

  const osbDetails = () => {
    const osbAmount = Math.abs(PrintData?.OSB ? Number(PrintData.OSB) : 0);
    const isOsb = Number(PrintData?.OSB) > 0;
    return `
      ${isOsb
        ? `<div style="display:flex; justify-content:space-between; border-top:1px dashed #000; border-bottom: 1px dashed #000; padding-top:5px;"><span>Outstanding(ر.ق):</span> <span>${roundAmount(
          osbAmount,
        )} </span></div>`
        : `<div style="display:flex; justify-content:space-between; border-top:1px dashed #000; border-bottom: 1px dashed #000; padding-top:5px;"><span>Advance(ر.ق):</span> <span>${roundAmount(
          osbAmount,
        )} </span></div>`
      }
      `;
  };

  const normalDesign = () => {
    return `
    <table style="width: 100%; border-collapse: collapse; margin-bottom: 5px; border-bottom: 1px dashed #000;">
      <thead style="border-bottom: 1px dashed #000;">
         <tr>
          <th class="col-no">#</th>
          <th class="col-name">Product Name</th>
          <th class="col-qty">Qty</th>
          <th class="col-price">Price</th>
          <th class="col-total">Total</th>
        </tr>
      </thead>
      <tbody>
        ${PrintData?.Products?.map(
      (p, index) => `
          <tr>
           <td class="col-no" style>${index + 1}</td>
              <td class="col-name">
              ${p.productName}
              <br/>
              <span style="font-size: 10px; font-style: italic; font-family: 'Tahoma', sans-serif;">
                ${p.arabicword ?? ""}
              </span>
            </td>
            <td class="col-qty">${p.quantity}${PrintData?.businessType === "Grocery" ? p.uom?.substring(0, 3).toLowerCase() : ""}</td>
            <td class="col-price">${roundAmount(p.amount)}</td>
            <td class="col-total">${roundAmount(p.totalPrice)}</td>
          </tr>
          ${p.addOns && p.addOns.length > 0
          ? p.addOns
            .map(
              (s, sIndex) => `
              
              <!-- SERVICE ROW -->
              <tr>
                <td></td>
                
                <td style="padding-left:20px;font-size:11px;">
                   ${sIndex + 1} ${s.text}
                </td>

                <td></td>

                <td style="font-size:11px;">
                  ${roundAmount(s.amount)}
                </td>

                <td style="font-size:11px;">
                  
                </td>
              </tr>
            `,
            )
            .join("")
          : ""
        }
        `,
    ).join("") || ""
      }
      </tbody>
    </table>`;
  };

  const carwashorderdetails = () => {
    const printDataAny = PrintData as any;
    const cars = printDataAny?.cars || [];
    const allProducts = PrintData?.Products || [];

    if (cars.length === 0 && allProducts.length === 0) {
      return "<div>No order data available</div>";
    }

    const formatPrice = (price: any) => {
      const num = Number(price);
      return isNaN(num) ? "0.00" : num.toFixed(2);
    };

    let vehiclesCount = 0;
    let grandTotal = 0;

    const carsHtml = cars
      .map((car: any, index: number) => {
        vehiclesCount++;
        let carSubtotal = 0;

        const products = car?.services?.[0]?.productDetails || [];

        if (products.length === 0) return "";

        const productRows = products
          .map((product: any) => {
            const price = Number(product.price) || 0;
            carSubtotal += price;
            grandTotal += price;

            return `
            <div style="display: flex; justify-content: space-between; padding: 4px 0;">
              <div style="padding-left: 15px;">${product.product || ""}</div>
              <div>${formatPrice(price)}</div>
            </div>
          `;
          })
          .join("");

        return `
        <div style="margin-top: 12px;">
          <div style="font-weight: bold; margin-bottom: 5px;">${car.carNumber || `CAR-${index + 1}`}</div>
          ${productRows}
          <div style="display: flex; justify-content: space-between; padding: 4px 0; border-top: 1px dotted #ccc; margin-top: 4px; font-weight: bold;">
            <div>Car ${index + 1} Subtotal</div>
            <div>${formatPrice(carSubtotal)}</div>
          </div>
        </div>
      `;
      })
      .join("");

    return `
    <div style="margin: 15px 0; border-bottom: 1px dashed #000; padding-bottom: 10px;">
      <div style="font-weight: bold; margin-bottom: 15px; text-align: center;">
        MULTI-CAR ORDER - ${vehiclesCount} VEHICLES
      </div>
      
      ${carsHtml}
      
      <div style="border-top: 1px solid #000; margin: 15px 0 10px;"></div>
      
      <div style="display: flex; justify-content: space-between; margin-bottom: 5px;">
        <div>Vehicles:</div>
        <div>${vehiclesCount} cars</div>
      </div>
      
      <div style="display: flex; justify-content: space-between; font-weight: bold;">
        <div>Total:</div>
        <div>${formatPrice(grandTotal)}</div>
      </div>
    </div>
  `;
  };

  const businessTypes = user?.businessType || "";

  const balanceCondent = () => {
    return `
    <div style="
      margin-top:8px;
      padding-top:8px;
      display:flex;
      justify-content:space-between;
      align-items:stretch;
      gap:10px;
      width:100%;
      text-align:center;
    ">

      <div style="
        flex:1;
        display:flex;
        flex-direction:column;
        justify-content:space-between;
        align-items:center;
        gap:6px;
      ">
        <span style="
          font-weight:bold;
          font-size:13px;
          line-height:18px;
        ">
          Order Amount <br/>
          (المبلغ الإجمالي)
        </span>

        <span style="
          font-size:14px;
        ">
          ${roundAmount(PrintData?.total)} ر.ق
        </span>
      </div>

      <div style="
        flex:1;
        display:flex;
        flex-direction:column;
        justify-content:space-between;
        align-items:center;
        gap:6px;
      ">
        <span style="
          font-weight:bold;
          font-size:13px;
          line-height:18px;
        ">
          Total Paid <br/>
          (مدفوع)
        </span>

        <span style="
          font-size:14px;
        ">
          ${roundAmount(Number(PrintData?.resvedAmount) || 0)} ر.ق
        </span>
      </div>

      <div style="
        flex:1;
        display:flex;
        flex-direction:column;
        justify-content:space-between;
        align-items:center;
        gap:6px;
      ">
        <span style="
          font-weight:bold;
          font-size:13px;
          line-height:18px;
        ">
          Remaining Balance <br/>
          (المبلغ المتبقي)
        </span>

        <span style="
          font-size:14px;
        ">
          ${roundAmount(PrintData?.balanceReturned)} ر.ق
        </span>
      </div>

    </div>
  `;
  };

  /** ===============================`
   * RECEIPT HTML CONTENT
   * =============================== */
  const content = `
  <div class="receipt-content" style="font-family: Arial, sans-serif; width: 100%; padding: 5px;">

    ${companyData()}
    ${PrintData ? orderData() : ""}
    ${PrintData ? customerData() : ""}
    ${ledgerPaid ? ledgerList() : ""}
    ${PrintData ? (businessTypes === "Carwash" ? carwashorderdetails() : "") : ""}
    ${PrintData ? (businessTypes !== "Carwash" ? orderDetails() : "") : ""}
    ${PrintData?.returnProducts && PrintData.returnProducts.length > 0 ? returnOrderQty() : ""}
    ${PrintData?.balanceEnabiled ? balanceCondent() : ""}
    ${PrintData?.payMentHistoryAvabile ? printHistory() : ""}
    ${PrintData ? (businessTypes !== "Carwash" ? osbDetails() : "") : ""}


    ${barcodeTrue ? `<div style="text-align:center; margin-top:10px;"><img src="${barcodeDataUrl}" style="width:200px; height:50px;" /></div>` : ""}
    ${enabileTermsAndConditions && userConfigration.enableTermsAndConditions && userConfigration.termsAndConditionsEnglish ? `<div style="margin-top:10px;"><strong>Terms and Conditions:</strong><p>${formatTerms(userConfigration.termsAndConditionsEnglish)}</p></div>` : ""}
    ${enabileTermsAndConditions && userConfigration.enableTermsAndConditions && userConfigration.termsAndConditionsArabic ? `<div style="margin-top:10px;"><strong>Terms and Conditions (Arabic):</strong><p>${formatTerms(userConfigration.termsAndConditionsArabic)}</p></div>` : ""}
    <div style="margin-top:10px; display:flex; justify-content:center;">
      ${userConfigration?.contact_qr_codeAWS
      ? `<div style="flex:1; text-align:center;">
              <strong>Contact QR</strong><br/>
              <img src="${userConfigration.contact_qr_codeAWS}" style="width:140px; height:140px;" />
          </div>`
      : ""
    }
      ${userConfigration?.location_qr_codeAWS
      ? `<div style="flex:1; text-align:center;">
              <strong>Location QR</strong><br/>
              <img src="${userConfigration.location_qr_codeAWS}" style="width:140px; height:140px;" />
          </div>`
      : ""
    }
    </div>
    <div style="text-align: center; margin-top: 20px; border-top: 1px solid black; padding-top: 10px;">
    <div style="text-align:center; margin-top:10px; border-top:1px dashed #000; padding-top:5px;">
      <p>Thanks for visiting ${user?.orgName || COMPANY_NAME}</p>
      <p>Powered by ${COMPANY_NAME}</p>
    </div>

  </div>
  `;
  // const copies = userConfigration?.copyqty || 
  const copies = 1;

  const printData = `${printerCheck}
<body>
  ${Array.from({ length: copies })
      .map(
        (_, index) => `
      <div class="page .copy-break">
        ${content}
      </div>
      ${index < copies - 1 ? `<div class="copy-gap"></div>` : ""}
    `,
      )
      .join("")}
</body>
</html>`;

  /** ===============================
   * PRINTING SYSTEM (AUTO PAPER SIZE)
   * =============================== */
  const handlePrint = () => {
    if (toBoolean(userConfigration.appPrinterEnabled) === true) {
      handleAppPrint?.(printData);
    } else {
      // alert("Please select a printer in the printer configuration to enable printing.");
      if (isDisabled) return;
      setIsDisabled(true);

      const iframe = document.createElement("iframe");
      iframe.style.position = "absolute";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      document.body.appendChild(iframe);

      const printDoc = iframe.contentWindow?.document;

      if (printDoc) {
        printDoc.open();
        printDoc.write(printData);
        printDoc.close();

        const cleanup = () => {
          try {
            if (document.body.contains(iframe)) document.body.removeChild(iframe);
          } catch (e) { }
          setIsDisabled(false);
        };

        iframe.onload = () => {
          try {
            iframe.contentWindow?.focus();
            iframe.contentWindow?.print();
          } catch (e) { }

          const onAfterPrint = () => {
            try {
              isClosed?.(false);
            } catch (e) { }
            cleanup();
            try {
              iframe.contentWindow?.removeEventListener("afterprint", onAfterPrint);
            } catch (e) { }
          };

          try {
            iframe.contentWindow?.addEventListener("afterprint", onAfterPrint);
          } catch (e) { }

          setTimeout(() => {
            if (document.body.contains(iframe)) {
              try {
                isClosed?.(false);
              } catch (e) { }
              cleanup();
            }
          }, 2000);
        };
      }
    }
  };

  /** BARCODE GENERATION */
  useEffect(() => {
    if (PrintData?.OrderId) {
      const canvas = document.createElement("canvas");
      JsBarcode(canvas, String(PrintData.OrderId), {
        format: "CODE128",
        width: 2,
        height: 60,
        displayValue: false,
      });
      setBarcodeDataUrl(canvas.toDataURL("image/png"));
    }
  }, [PrintData?.OrderId]);

  /** AUTO PRINT */
  useEffect(() => {
    if (!openPrint) return;
    // if barcode is expected, wait until it's generated
    if (barcodeTrue && !barcodeDataUrl) return;
    // If ledgerPaid is provided or PrintData is present, proceed
    handlePrint();
  }, [openPrint, barcodeDataUrl, barcodeTrue, ledgerPaid]);

  return (
    <div>
      {(BtnName || icon) &&
        (user?.businessType === "Grocery" ? (
          <Button className={className} label={BtnName} onClick={handlePrint} icon={icon} radius="rounded-full" font="font-bold" />
        ) : (
          <CommonButtons label={BtnName} onClick={handlePrint} icon={icon} className={className} />
        ))}
    </div>
  );
};

export default ThermalPrinter2;
